import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IRefDiagnosisRelatedGroup extends IModelBase {
  Code: string
  Description: string
}

@Injectable()
export class RefDiagnosisRelatedGroupODataService extends ODataService<IRefDiagnosisRelatedGroup> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RefDiagnosisRelatedGroups'
  }
}
